module.exports = __webpack_public_path__ + "img/wet-street-night.f40fd4a8.jpg";